import { Fragment } from "react";
import { motion } from "framer-motion";
import { useModal } from "../../stores/modal";
import { useHideOverflow } from "../../hooks/useHideOverflow";
import { useOutsideClick } from "../../hooks/useClickOutside";
import { cx } from "class-variance-authority";

export const Modal = () => {
  const close = useModal((state) => state.close);
  const content = useModal((state) => state.content);
  const modalRef = useOutsideClick(close);
  useHideOverflow(content, content?.state);

  let animationProps;

  switch (content.animation) {
    case "slide-up":
      animationProps = {
        initial: { opacity: 0, y: 300 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: 300 },
        transition: { duration: 0.3 },
      };
      break;
    case "slide-down":
      animationProps = {
        initial: { opacity: 0, y: -300 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: -300 },
        transition: { duration: 0.3 },
      };
      break;
    default:
      animationProps = {
        initial: { opacity: 0, y: -300 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: -300 },
        transition: { duration: 0.3 },
      };
      break;
  }

  return (
    <Fragment>
      <div
        className={cx(
          "w-screen h-[100dvh] md:h-screen",
          "fixed top-0 left-0 z-[60]",
          "bg-black/30 overflow-y-auto",
          "flex items-start justify-center",
          content.position == "center"
            ? "md:items-center"
            : content.position == "bottom"
              ? "items-end"
              : "md:items-start",
        )}
      >
        <div
          className={cx(
            "h-fit w-full",
            content.width ? "my-[24px] mx-[24px]" : "",
          )}
          style={{
            zIndex: 33,
            maxWidth: content.width ? `${content.width}px` : undefined,
          }}
        >
          <motion.div
            {...animationProps}
            ref={modalRef}
            key="modal-content"
            id="modal-content"
            className="w-full"
          >
            {content.html}
          </motion.div>
        </div>
      </div>
    </Fragment>
  );
};
